module.exports = __webpack_public_path__ + "img/step1.67528831.png";